import { useTypedNode } from './useTypedNode'

import type { ViewModel } from '@rehaje/core'

export const useViewModel = <T extends ViewModel = ViewModel>():
  | T
  | undefined => {
  return useTypedNode()?.__r_getSelfViewElement()?.model as T | undefined
}
